interface SortOption {
  value: string;
  direction: string;
  label: string;
}

interface FilterOption {
  value: string;
  label: string;
}

export function getSortOptionFromQuery(
  sortBy: string | undefined,
  sortDirection: string | undefined,
  options: Record<string, SortOption>,
): string {
  const sortOption = Object.keys(options).find(
    key => options[key].value === sortBy && options[key].direction === sortDirection,
  );

  return sortOption || Object.keys(options)[0];
}

export function getStatusFromQuery(
  status: string | undefined,
  options: Record<string, FilterOption>,
): string {
  const statusOption = Object.keys(options).find(key => options[key].value === status);

  return statusOption || Object.keys(options)[0];
}
